const state = {
  addressId: '', // 支付地址
  payType: '', // 支付方式 cart 购物车结算 buyNow 立即购买结算
  payInfo: [], // 支付信息
  cartInfo: {}, // key 是 goods_sn, value 是 cart_id
  movieInfo: {}, // 电影信息
  goodsType: '', // 商品类型
  paymentType: {
    // 支付类型
    cart: 'cart',
    buyNow: 'buyNow'
  },
  // 福利卡信息
  welfareCard: {},
  orderId: '', // 订单号
  // 支付方式
  payWay: {
    saas: [], // saas支付方式 积分| 余额| 优惠劵
    cansh: [] // 现金支付方式 微信 | 支付宝 | 银联
  },
  address: {},
  addressInfo: {},
  cakeShop: {}, // 蛋糕门店
  cakeDelivery: ''
}

export default state
